import { Common } from '@stockbit/ui';
import { address, companyName, phone, supportEmail } from 'constants/company';
import GoogleMap from 'features/static/GoogleMap';
import { AboutContainer, Title, Paragraph } from '../styled';
import { ContactBox, ContactContainer, ContactItem } from './styled';

const { Text } = Common;

const Contact = () => (
  <AboutContainer>
    <Title align="center" mb="60px">Hubungi Kami</Title>
    <ContactContainer>
      <ContactBox className="map">
        <GoogleMap />
      </ContactBox>
      <ContactBox>
        <ContactItem icon="images/location.svg">
          <Text as="h5" family="bold" mb="15px" size="19px">
            {companyName}
          </Text>
          <Paragraph>{address}</Paragraph>
        </ContactItem>
        <ContactItem icon="images/email.svg">
          <Text as="h5" family="bold" mb="15px" size="19px">
            Kontak Utama
          </Text>
          <Paragraph>
            Untuk segala pertanyaan dan masalah, kamu dapat mengunjungi pusat
            bantuan kami. Jika kamu membutuhkan bantuan lebih jauh, kamu dapat
            mengirimkan email ke{' '}
            <Text as="b" family="bold" size="19px">
              {supportEmail}
            </Text>
            .
          </Paragraph>
        </ContactItem>
        <ContactItem icon="images/phone.svg">
          <Text as="h5" family="bold" mb="15px" size="19px">
            Telepon
          </Text>
          <Paragraph>{phone}</Paragraph>
        </ContactItem>
      </ContactBox>
    </ContactContainer>
  </AboutContainer>
);

export default Contact;
